import { GraphQLError } from "graphql";

export const ERRORS = {
  E_1: "Неправильный запрос",
  E_2: "Метод не найден",
  E_3: "Произошла ошибка",
  E_4: "Телефон занят",
  E_5: "Некорректный электронный адрес",
  E_6: "Логин и пароль не заполнены",
  E_7: "Пользователь не найден",
  E_8: "Почтовый ящик занят",
  E_9: "Правила сервиса не подтверждены",
  E_10: "Логин введен в неверном формате",
  E_11: 'Поле "Имя" обязательно для заполнения',
  E_12: "Время действия ключа авторизации истекло или ключ отсутствует",
  E_13: "Некорректный электронный адрес",
  E_14: "Регион не выбран",
  E_15: "Регион не найден",
  E_16: "Новые пароли не совпадают",
  E_17: "Найдено более %count% позиций. Пожалуйста, уточните поиск.",
  E_18: "Запрос слишком короткий. Пожалуйста, уточните поиск.",
  E_19: "Ничего не найдено. Пожалуйста, уточните поиск.",
  E_20: "Товар не найден",
  E_21: "Сообщение слишком короткое",
  E_22: "Ошибка добавления отзыва",
  E_27: "Посещение с данного устройства уже было",
  E_28: "Неверный тип устройства",
  E_23: "Не задан ID аптеки",
  E_24: 'Не заполнено поле "Причина"',
  E_25: "Форма не найдена",
  E_26: "Ошибка отправки формы",
  E_29: "Минимальная сумма заказа %min_sum% р. Наполните корзину ещё.",
  E_30: "Неверный пароль",
  E_31: "Аптека неактивна. Пожалуйста, выберите другую аптеку",
  E_32: "Старый пароль введён неверно",
  E_33: "Заказ не найден",
  E_34: "Товаров нет в наличии",
  E_35: "Доставка курьером недоступна",
  E_36: "Не заполнено поле %field%",
  E_250: "Превышен лимит запросов по данному методу",
  E_37: "Смена телефона недоступна",
  E_100: "Корзина пустая",
  E_110: "Корзина была изменена",
  E_38: "Заказ не удалось отменить",
  E_39: "Заказ не удалось отменить (он уже собран или отправлен)",
  E_251:
    "К сожалению, в настоящее время оформление заказа невозможно. Повторите попытку через 24 часа",
  E_120: "Отсутствуют доступные способы получения",
  E_130: "Не удалось сохранить заказ. Повторите попытку позднее",
  E_260: "Повторная отправка SMS пока недоступна. Попробуйте позже",
  E_270: "Категория не найдена",
  E_261: "msg",
  E_40: "По заказу не была произведена онлайн оплата]",
  E_258: "Вы исчерпали количество попыток ввода кода, запросите новый SMS-код",
  E_259: "Неверный код",
  E_41: "Указанная карта не найдена",
  E_70: "Не пройдена проверка reCaptcha",
};

type ErrorsCodes = keyof typeof ERRORS;

export function getErrorCode(errString: string): string {
  const codes = errString?.match(/(=.*?,)/);
  return codes ? codes[0].slice(1, -1) : "E_3";
}

export function getErrorMessage(errCode: ErrorsCodes): string {
  return errCode ? ERRORS[errCode] : "Ошибка запроса";
}

interface GetGQLErrorExtensionResult extends GraphQLError {
  extensions: {
    code?: string | number;
    message?: string;
  };
}
export function getGQLErrorExtension(
  code: string | number,
  errors: ReadonlyArray<GraphQLError> = []
): GetGQLErrorExtensionResult {
  return errors?.find(error => error.extensions?.code === code);
}

export function hasGQLErrorCode(
  code: string | number,
  errors: ReadonlyArray<GraphQLError> = []
): boolean {
  return errors.some(error => error.extensions?.code === code);
}
